import { useState, useEffect, useMemo, useRef, useContext } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { ICONS } from "../icons";
import { AuthContext } from "../context/AuthContext";
import { useSystemConfig } from "../context/SystemConfigContext";
import { useSystemConfigWS } from "../hooks/useSystemConfigWS";
import { getAssetUrl } from "../services/api";
import api, { logout as apiLogout } from "../services/api";
import NotificationBell from "../components/UI/NotificationBell";
import HeaderSearch from "../components/UI/HeaderSearch";
import LanguagePicker from "../components/UI/LanguagePicker";
import { useTranslation, I18nContext } from "../context/I18nContext";
// --- [تعديل] استبدال مكتبة Tippy بـ Floating UI لحل مشاكل التوافق مع React 19 ---
import { 
  useFloating, 
  offset, 
  flip, 
  shift, 
  useHover, 
  useInteractions, 
  autoUpdate 
} from "@floating-ui/react";
// import Tippy from "@tippyjs/react"; // تم الاستغناء عنها
// import "tippy.js/dist/tippy.css"; 

import "./MainLayout.css";

// --- [تعديل] تحديث المكون لاستخدام Fixed Strategy ليتخطى أي Overflow في الـ Sidebar ---
function Tooltip({ children, label, disabled }) {
  const [isOpen, setIsOpen] = useState(false);
  // الـ Sidebar نفسه بيتقلب لناحية اليمين تلقائيًا في العربي (flexbox بيحترم
  // dir لوحده من غير أي كود إضافي)، فلو التولتيب فضل placement: "right"
  // ثابت، هيحاول يفتح ناحية اليمين برضه يعني برة الشاشة (مفيش مكان)، بدل ما
  // يفتح ناحية المحتوى (الشمال في العربي). placement والسهم بتاعه لازم
  // يتقلبوا مع اتجاه اللغة.
  const { languages, languageCode } = useContext(I18nContext);
  const isRTL = languages.find((l) => l.code === languageCode)?.direction === "rtl";

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: isRTL ? "left" : "right",
    // استراتيجية fixed تجعل التولتيب يطفو فوق كل شيء بغض النظر عن الـ Sidebar
    strategy: "fixed",
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(15),
      flip(),
      shift()
    ],
  });

  const hover = useHover(context, { enabled: !disabled });
  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

  return (
    <>
      <div ref={refs.setReference} {...getReferenceProps()} className="w-full">
        {children}
      </div>
      {isOpen && !disabled && (
        <div
          ref={refs.setFloating}
          style={{
            ...floatingStyles,
            backgroundColor: "#1f2937",
            color: "white",
            padding: "6px 10px",
            borderRadius: "4px",
            fontSize: "12px",
            zIndex: 10000, // رقم عالٍ جداً لضمان الظهور
            pointerEvents: "none",
            boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
          }}
          {...getFloatingProps()}
        >
          {label}
          {/* سهم صغير للتوضيح — لازم يتقلب مع placement فوق: لما التولتيب
              يفتح ناحية الشمال (isRTL) السهم بيبقى على يمين صندوق التولتيب
              وبيشاور يمين (باتجاه العنصر)، والعكس صحيح. */}
          <div style={isRTL ? {
            position: 'absolute',
            right: '-4px',
            top: '50%',
            transform: 'translateY(-50%)',
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
            borderLeft: '5px solid #1f2937'
          } : {
            position: 'absolute',
            left: '-4px',
            top: '50%',
            transform: 'translateY(-50%)',
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
            borderRight: '5px solid #1f2937'
          }} />
        </div>
      )}
    </>
  );
}
/* function ProfileMenu() {
  const [open, setOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open,
    onOpenChange: setOpen,
    placement: "bottom-end",
    strategy: "fixed",
    whileElementsMounted: autoUpdate,
    middleware: [offset(8), flip(), shift()],
  });

  const hover = useHover(context, { enabled: false }); // لن نستخدم hover هنا
  const { getReferenceProps, getFloatingProps } = useInteractions([]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    window.location.href = "/login";
  };

  return (
    <div className="profile-menu-container">
      <button
        ref={refs.setReference}
        {...getReferenceProps()}
        onClick={() => setOpen((prev) => !prev)}
        className="profile-avatar-btn"
      >
        <img
          src="/assets/avatar.png"
          alt="User"
          className="profile-avatar"
        />
      </button>

      {open && (
        <div
          ref={refs.setFloating}
          style={{
            ...floatingStyles,
            background: "white",
            color: "#111827",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            minWidth: "180px",
            zIndex: 10000,
            overflow: "hidden",
          }}
          {...getFloatingProps()}
        >
          <div className="profile-menu">
            <div className="profile-info">
              <img src="/assets/avatar.png" alt="User" className="profile-avatar small" />
              <div className="profile-text">
                <strong>Admin User</strong>
                <small>admin@system.com</small>
              </div>
            </div>
            <hr className="menu-divider" />
            <button className="menu-item" onClick={() => (window.location.href = "/profile")}>
  <RenderIcon icon={ICONS.profile} size={16} /> View Profile
</button>

<button className="menu-item" onClick={() => alert("Settings clicked")}>
  <RenderIcon icon={ICONS.settings} size={16} /> Settings
</button>

<button className="menu-item logout" onClick={handleLogout}>
  <RenderIcon icon={ICONS.logout} size={16} /> Logout
</button>

          </div>
        </div>
      )}
    </div>
  );
} */

  

  function ProfileMenu() {
    const { t: tHeader } = useTranslation("header");
    const [open, setOpen] = useState(false);
    // بيانات البروفايل (بما فيها الصورة) بقت متمركزة في AuthContext بدل ما
    // تتجاب هنا لوحدها — عشان لما صفحة البروفايل تحفظ صورة جديدة (أو تعمل
    // Reset Photo)، تقدر تحدّث النسخة المشتركة دي فيتحدث الهيدر فورًا من
    // غير أي إعادة تحميل للصفحة. راجع AuthContext.js.
    const { userProfile: user } = useContext(AuthContext);
    const menuRef = useRef(null); // 📌 مرجع للمكون
    const { refs, floatingStyles } = useFloating({
      open,
      onOpenChange: setOpen,
      placement: "bottom-end",
      strategy: "fixed",
      whileElementsMounted: autoUpdate,
      middleware: [offset(8), flip(), shift()],
    });

    useEffect(() => {
      function handleClickOutside(event) {
        if (
          menuRef.current &&
          !menuRef.current.contains(event.target) &&
          !refs.reference.current?.contains(event.target)
        ) {
          setOpen(false);
        }
      }
      if (open) {
        document.addEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [open, refs.reference]);
    
  
    /* const handleLogout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("userProfile");
      window.location.href = "/login";
    }; */

    // أضف كلمة async هنا
    const handleLogout = async (e) => {
      if (e) e.preventDefault();
      console.log("🚀 Logout process started...");
      
      const token = localStorage.getItem("token");
    
      try {
        if (token) {
          console.log("📡 Sending request to backend...");
          
          // ✅ التأكد إن السيرفر استلم الطلب فعلاً قبل ما نتحرك
          const response = await apiLogout(token); 
          console.log("✅ Server acknowledged logout", response);
        }
      } catch (error) {
        console.error("❌ Logout Request Failed:", error);
      } finally {
        // ⚠️ متمسحش التوكن ولا تحول إلا لما الطلب يخلص (ده اللي الـ await بيضمنه)
        console.log("🧹 Cleaning up local storage...");
        localStorage.removeItem("token");
        localStorage.removeItem("userProfile");
        
        // ✅ التحويل يتم هنا في الآخر خالص
        window.location.href = "/login";
      }
    };

    const defaultAvatar =
      getAssetUrl(user?.gender === "female" ? "/img/avatars/Female-2.png" : "/img/avatars/Male.jpg");

    const avatarSrc = user?.avatar_url ? getAssetUrl(user.avatar_url) : defaultAvatar;
  
    return (
      <div className="profile-menu-container" ref={menuRef}>
        {/* زر الصورة */}
        <button
          ref={refs.setReference}
          onClick={() => setOpen((prev) => !prev)}
          className="profile-avatar-btn"
        >
          <img src={avatarSrc} alt="User Avatar" className="profile-avatar" />
        </button>
  
        {/* القائمة المنسدلة */}
        {open && (
          <div
            ref={refs.setFloating}
            style={{
              ...floatingStyles,
              background: "white",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              minWidth: "220px",
              zIndex: 10000,
            }}
          >
            <div className="profile-menu">
              <div className="profile-info">
                <img src={avatarSrc} alt="User" className="profile-avatar small" />
                <div className="profile-text">
                  <strong>{[user?.first_name, user?.last_name].filter(Boolean).join(" ") || user?.username || tHeader("profile_default_name", "User")}</strong>
                  <small>{user?.job_title || user?.email || ""}</small>
                </div>
              </div>
  
              <hr className="menu-divider" />
  
              <button
                className="menu-item"
                onClick={() => (window.location.href = "/profile")}
              >
                <RenderIcon icon={ICONS.Profile} size={16} /> {tHeader("profile_view_profile", "View Profile")}
              </button>
  
              {user?.groups?.[0]?.name && (
                <div className="menu-item text-gray-500 text-xs cursor-default">
                  <RenderIcon icon={ICONS.Groups} size={14} />
                  {user.groups[0].name}
                </div>
              )}
  
              <button className="menu-item logout" onClick={handleLogout}>
                <RenderIcon icon={ICONS.Logout} size={16} /> {tHeader("profile_logout", "Logout")}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
  
  

function RenderIcon({ icon, size = 20, className = "" }) {
  if (!icon) return null;
  const IconComponent = icon;
  return <IconComponent className={className} width={size} height={size} />;
}


// Recursively keeps only the menu items this user is actually allowed to
// see: a leaf item needs either no gate at all (item.permission and
// item.permissionPrefix both unset — e.g. Dashboard, Profile), an exact
// permission match (item.permission, mirroring each route's own
// requiredPermission in App.js), or — for Reports, gated per-report rather
// than by one fixed permission (see routes.go's own doc comment) — at
// least one permission starting with item.permissionPrefix. A parent item
// (has "children" instead of "path") is kept only if at least one of its
// children survives filtering; if every child is filtered out, the parent
// disappears too instead of showing an empty, useless expandable group.
function filterMenuItems(items, userPermissions) {
  const perms = userPermissions || [];
  const out = [];
  for (const item of items) {
    if (item.children) {
      const children = filterMenuItems(item.children, perms);
      if (children.length > 0) out.push({ ...item, children });
      continue;
    }
    if (!item.permission && !item.permissionPrefix) {
      out.push(item);
      continue;
    }
    const visible = item.permission
      ? perms.includes(item.permission)
      : perms.some((p) => p.startsWith(item.permissionPrefix));
    if (visible) out.push(item);
  }
  return out;
}

export default function MainLayout() {
  const { userPermissions } = useContext(AuthContext);
  const { t } = useTranslation("sidebar");
  const { t: tHeader } = useTranslation("header");
  const { t: tFooter } = useTranslation("footer");
  // system_name can come back translated per the signed-in user's own
  // language (resolved server-side, see applyTranslatedSystemName in
  // config_handler.go) — loadSettings below needs to re-run whenever
  // languageCode changes, or a language switch would silently keep
  // showing the name resolved under the PREVIOUS language in the header
  // title until the next full page reload.
  const { languageCode } = useContext(I18nContext);
  const { systemSettings, setSystemSettings } = useSystemConfig();
  const [collapsed, setCollapsed] = useState(() => JSON.parse(localStorage.getItem("sidebar-collapsed")) || false);
  const [openMenus, setOpenMenus] = useState(() => JSON.parse(localStorage.getItem("open-menus")) || {});
  const [drawerOpen, setDrawerOpen] = useState(false);

  const loadSettings = async (forceFromDB = false) => {
    try {
      const res = await api.get("/public-config");
      const freshSettings = res.data;

      if (freshSettings) {
        setSystemSettings(freshSettings);
        localStorage.setItem("systemSettings", JSON.stringify(freshSettings));
        console.log("✅ Settings synced from Server");
      }
    } catch (err) {
      console.error("❌ Failed to fetch from server, falling back to cache:", err);
      const cached = localStorage.getItem("systemSettings");
      if (cached) {
        setSystemSettings(JSON.parse(cached));
      }
    }
  };

  useEffect(() => {
    loadSettings();
  }, [languageCode]);

  useSystemConfigWS(async () => {
    await new Promise((r) => setTimeout(r, 600)); 
    await loadSettings(true); 
  });

  const systemName = useMemo(() => 
    systemSettings?.general?.system_name || "POSFLECT"
  , [systemSettings]);

  const themeColor = useMemo(() =>
    systemSettings?.appearance?.theme_color || "#203664"
  , [systemSettings]);

  // Config > Appearance's uploaded "logo" — the sidebar falls back to the
  // plain text systemName (the pre-existing behavior) when nothing's been
  // uploaded. getAssetUrl attaches the signed-in user's own token, since
  // /uploads is gated behind StaticAssetAuth — fine here, MainLayout only
  // ever renders once there IS a token.
  const logoUrl = useMemo(() => {
    const path = systemSettings?.appearance?.logo;
    return path ? getAssetUrl(path) : null;
  }, [systemSettings]);

  useEffect(() => { localStorage.setItem("sidebar-collapsed", JSON.stringify(collapsed)); }, [collapsed]);
  useEffect(() => { localStorage.setItem("open-menus", JSON.stringify(openMenus)); }, [openMenus]);

  const toggleMenu = (name) => {
    setOpenMenus((prev) => ({ ...prev, [name]: !prev[name] }));
  };
  

  // Every leaf's "permission" mirrors that exact route's own
  // requiredPermission in App.js — kept in sync by hand the same way
  // App.js's routes and internal/config/seed_admin.go's allPermissions
  // already are (see that file's own doc comment). Dashboard/Profile have
  // no gate at all (bare <ProtectedRoute> — everyone signed in can open
  // them), and Reports uses "permissionPrefix" instead of a single fixed
  // "permission": since viewing is per-report ("report_view_<key>", see
  // routes.go's own doc comment), the item should show as long as the user
  // holds AT LEAST ONE of those, not one specific name.
  // Each item's "name" stays the stable English identifier used for React
  // keys, openMenus state, and the Tooltip's own key prop — never shown
  // directly to a translated user anymore. "tkey" is what actually renders
  // (see renderMenu below): a lookup into the "sidebar" namespace seeded in
  // internal/config/seed_translations.go, falling back to "name" itself
  // (English) for the instant before that bundle loads, or forever if a
  // future menu item's tkey isn't seeded yet.
  const menuItems = [
    { name: "Dashboard", tkey: "menu.dashboard", path: "/dashboard", icon: ICONS.Dashboard },
    { name: "Reports", tkey: "menu.reports", path: "/reports", icon: ICONS.Reports, permissionPrefix: "report_view_" },
    {
      name: "POS",
      tkey: "menu.pos",
      icon: ICONS.POS,
      children: [
        { name: "Checkout", tkey: "menu.checkout", path: "/checkout", icon: ICONS.Checkout, permission: "order_create" },
        { name: "Orders", tkey: "menu.orders", path: "/orders", icon: ICONS.Orders, permission: "order_view" },
        // Kitchen Display — gated by "order_kitchen_update" rather than
        // "order_view", same as its own feed endpoint (see
        // ListKitchenOrdersHandler's doc comment in order_handler.go): a
        // user handed only kitchen duty still sees this entry without also
        // needing full sales-history access.
        { name: "Kitchen Display", tkey: "menu.kitchen_display", path: "/kitchen-display", icon: ICONS.KitchenDisplay, permission: "order_kitchen_update" },
        { name: "Shifts", tkey: "menu.shifts", path: "/shifts", icon: ICONS.Shifts, permission: "shift_view" },
        { name: "Vouchers", tkey: "menu.vouchers", path: "/vouchers", icon: ICONS.Vouchers, permission: "voucher_view" },
        { name: "Customers", tkey: "menu.customers", path: "/customers", icon: ICONS.Customers, permission: "customer_view" },
        { name: "Suppliers", tkey: "menu.suppliers", path: "/suppliers", icon: ICONS.Suppliers, permission: "supplier_view" },
        { name: "Purchase Orders", tkey: "menu.purchase_orders", path: "/purchase-orders", icon: ICONS.PurchaseOrders, permission: "purchaseorder_view" },
        { name: "Stock Transfers", tkey: "menu.stock_transfers", path: "/stock-transfers", icon: ICONS.StockTransfers, permission: "stocktransfer_view" },
        { name: "Branches", tkey: "menu.branches", path: "/branches", icon: ICONS.Branches, permission: "branch_view" },
        { name: "Sections", tkey: "menu.sections", path: "/sections", icon: ICONS.Sections, permission: "section_view" },
        { name: "Tables", tkey: "menu.tables", path: "/tables", icon: ICONS.Tables, permission: "table_view" },
        { name: "Categories", tkey: "menu.categories", path: "/categories", icon: ICONS.Categories, permission: "category_view" },
        { name: "Units", tkey: "menu.units", path: "/units", icon: ICONS.Units, permission: "unit_view" },
        { name: "Taxes", tkey: "menu.taxes", path: "/taxes", icon: ICONS.Taxes, permission: "tax_view" },
        { name: "Tax Groups", tkey: "menu.tax_groups", path: "/tax-groups", icon: ICONS.TaxGroups, permission: "taxgroup_view" },
        { name: "Currencies", tkey: "menu.currencies", path: "/currencies", icon: ICONS.Currencies, permission: "currency_view" },
        { name: "Products", tkey: "menu.products", path: "/products", icon: ICONS.Products, permission: "product_view" },
        { name: "Inventory", tkey: "menu.inventory", path: "/inventory", icon: ICONS.Inventory, permission: "inventory_view" },
        { name: "Discounts", tkey: "menu.discounts", path: "/discounts", icon: ICONS.Discounts, permission: "sale_view" },
        { name: "Bundle Offers", tkey: "menu.bundle_offers", path: "/bundle-offers", icon: ICONS.BundleOffers, permission: "bundleoffer_view" },
        // Services & Appointments module — gated purely by service_view
        // like every other item here, not by any branch's BusinessType:
        // there is no per-user "current branch" concept in the admin panel
        // to gate a sidebar entry by (unlike Checkout, which knows the open
        // shift's own branch — see ServiceCapableBusinessTypes in
        // branch_handler.go). Services is admin data management, usable
        // regardless of which branch ends up selling it.
        { name: "Services", tkey: "menu.services", path: "/services", icon: ICONS.Services, permission: "service_view" },
        // Appointments — the booking calendar, its own permission
        // (appointment_view) separate from service_view, same reasoning as
        // seed_admin.go's own comment on appointment_* permissions.
        { name: "Appointments", tkey: "menu.appointments", path: "/appointments", icon: ICONS.Appointments, permission: "appointment_view" },
      ],
    },
    {
      // Printing — Thermal Receipt Printing (ESC/POS) via Print-Agent (see
      // models.PrintAgent/Printer/ReceiptTemplate on the backend). Its own
      // top-level group, same as Accounting below, rather than folded into
      // POS above — this is admin-configured infrastructure (which
      // machines/printers exist, how a receipt looks), not day-to-day
      // sales activity.
      name: "Printing",
      tkey: "menu.printing",
      icon: ICONS.Printers,
      children: [
        { name: "Print Agents", tkey: "menu.print_agents", path: "/print-agents", icon: ICONS.PrintAgents, permission: "printer_view" },
        { name: "Printers", tkey: "menu.printers", path: "/printers", icon: ICONS.Printers, permission: "printer_view" },
        { name: "Print Jobs", tkey: "menu.print_jobs", path: "/print-jobs", icon: ICONS.PrintJobs, permission: "printer_view" },
        { name: "Print Barcodes", tkey: "menu.print_barcodes", path: "/print-barcodes", icon: ICONS.PrintBarcodes, permission: "print_labels" },
        { name: "Receipt Template", tkey: "menu.receipt_template", path: "/receipt-template", icon: ICONS.ReceiptTemplate, permission: "printer_view" },
        // Local Print Setup — deliberately "print_receipt" here too, not
        // "printer_view" like every sibling above: this is a per-till setup
        // screen an ordinary cashier runs on their own machine (see
        // LocalPrintSetup.js's own doc comment), not an admin list.
        { name: "Local Print Setup", tkey: "menu.local_print_setup", path: "/local-print-setup", icon: ICONS.Config, permission: "print_receipt" },
      ],
    },
    {
      name: "Accounting",
      tkey: "menu.accounting",
      icon: ICONS.Accounting,
      children: [
        { name: "Chart of Accounts", tkey: "menu.chart_of_accounts", path: "/accounts", icon: ICONS.ChartOfAccounts, permission: "account_view" },
        { name: "Journal Entries", tkey: "menu.journal_entries", path: "/journal-entries", icon: ICONS.JournalEntries, permission: "journalentry_view" },
        { name: "Expenses", tkey: "menu.expenses", path: "/expenses", icon: ICONS.Expenses, permission: "expense_view" },
        { name: "Expense Categories", tkey: "menu.expense_categories", path: "/expense-categories", icon: ICONS.ExpenseCategories, permission: "expensecategory_view" },
      ],
    },
    {
      name: "System",
      tkey: "menu.system",
      icon: ICONS.Settings,
      children: [
        {
          name: "Manage Users",
          tkey: "menu.manage_users",
          icon: ICONS.UserManagement,
          children: [
            { name: "Users", tkey: "menu.users", path: "/users", icon: ICONS.Users, permission: "user_view" },
            { name: "Groups", tkey: "menu.groups", path: "/groups", icon: ICONS.Groups, permission: "group_view" },
          ],
        },
        { name: "Permissions", tkey: "menu.permissions", path: "/permissions", icon: ICONS.Permissions, permission: "permission_view" },
        { name: "Config", tkey: "menu.config", path: "/config", icon: ICONS.Config, permission: "config_view" },
        { name: "Events", tkey: "menu.events", path: "/events", icon: ICONS.BellAlert, permission: "event_view" },
        { name: "System Logs", tkey: "menu.system_logs", path: "/logs", icon: ICONS.Logs, permission: "activity_log_view" },
        {
          name: "Geography",
          tkey: "menu.geography",
          icon: ICONS.Geography,
          children: [
            { name: "Countries", tkey: "menu.countries", path: "/countries", icon: ICONS.Countries, permission: "country_view" },
            { name: "Zones", tkey: "menu.zones", path: "/zones", icon: ICONS.Zones, permission: "zone_view" },
            { name: "Cities", tkey: "menu.cities", path: "/cities", icon: ICONS.Cities, permission: "city_view" },
            { name: "Geo Zones", tkey: "menu.geo_zones", path: "/geozones", icon: ICONS.GeoZones, permission: "geozone_view" },
          ],
        },
        { name: "Modules", tkey: "menu.modules", path: "/modules", icon: ICONS.Modules, permission: "module_manage" },
        { name: "Custom Fields", tkey: "menu.custom_fields", path: "/custom-fields", icon: ICONS.CustomFields, permission: "customfield_manage" },
        { name: "Translations", tkey: "menu.translations", path: "/translations", icon: ICONS.Geography, permission: "language_view" },
        { name: "Languages", tkey: "menu.languages", path: "/languages", icon: ICONS.Geography, permission: "language_view" },
      ],
    },
    { name: "Profile", tkey: "menu.profile", path: "/profile", icon: ICONS.Profile },
  ];

  const visibleMenuItems = useMemo(
    () => filterMenuItems(menuItems, userPermissions),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userPermissions]
  );

  // searchableItems: the flattened, translated leaf list HeaderSearch
  // filters against — built straight off visibleMenuItems (already
  // permission-filtered above) so a search result can never point at a
  // page the signed-in user isn't allowed to open. Only items with an
  // actual `path` are kept — a group heading like "POS"/"System" has none
  // of its own (it just expands children in the sidebar), so it's dropped
  // here rather than showing up as a dead-end search result. `group` is
  // the breadcrumb of parent group labels (e.g. "System / Geography"),
  // shown under the label so two similarly-named pages in different
  // sections stay distinguishable.
  const searchableItems = useMemo(() => {
    const flatten = (items, groupPath) => {
      const out = [];
      for (const item of items) {
        if (item.children) {
          const groupLabel = t(item.tkey, item.name);
          out.push(...flatten(item.children, [...groupPath, groupLabel]));
          continue;
        }
        if (item.path) {
          out.push({
            label: t(item.tkey, item.name),
            path: item.path,
            icon: item.icon,
            group: groupPath.join(" / "),
          });
        }
      }
      return out;
    };
    return flatten(visibleMenuItems, []);
  }, [visibleMenuItems, t]);

  const renderMenu = (items, level = 0) => (
    <ul className={`menu-level level-${level}`}>
      {items.map((item) => {
        const Icon = item.icon;
        const hasChildren = !!item.children;
        const isOpen = openMenus[item.name];
        const label = t(item.tkey, item.name);

        const ItemInner = (
          <div className="item-content">
            <div className="menu-icon">{Icon && <Icon size={20} />}</div>
            {!collapsed && <span className="menu-text">{label}</span>}
            {hasChildren && !collapsed && (
              <span className={`arrow ${isOpen ? "rotated" : ""}`}>▸</span>
            )}
          </div>
        );

        // --- [تعديل] استبدال منطق Tippy بمكون الـ Tooltip الجديد المتوافق مع React 19 ---
        const withTooltip = (content) => (
          <Tooltip
            label={label}
            disabled={!collapsed}
            key={item.name}
          >
            {content}
          </Tooltip>
        );

       
        

        return (
          <li key={item.name} className="menu-li">
            {hasChildren ? (
              <>
                {withTooltip(
                  <div 
                    className={`nav-item dropdown-btn ${isOpen ? "is-open" : ""}`}
                    onClick={() => toggleMenu(item.name)}
                  >
                    {ItemInner}
                  </div>
                )}
                <div className={`submenu ${isOpen ? "open" : ""}`}>
                  {renderMenu(item.children, level + 1)}
                </div>
              </>
            ) : (
              withTooltip(
                <NavLink 
                  to={item.path} 
                  className={({ isActive }) => `nav-item link-item ${isActive ? "active" : ""}`}
                  onClick={() => setDrawerOpen(false)}
                >
                  {ItemInner}
                </NavLink>
              )
            )}
          </li>
        );
      })}
    </ul>
  );

  return (
    <div className={`layout-container ${collapsed ? "collapsed" : ""}`}
    style={{ "--theme-color": themeColor }}
    >
      {drawerOpen && <div className="overlay" onClick={() => setDrawerOpen(false)} />}
      
      <aside className={`sidebar ${drawerOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          {!collapsed && (
            logoUrl ? (
              <img src={logoUrl} alt={systemName} className="logo" style={{ maxHeight: 36, maxWidth: 160, objectFit: "contain" }} />
            ) : (
              <h2 className="logo">{systemName}</h2>
            )
          )}
          <button className="toggle-btn" onClick={() => setCollapsed(!collapsed)}>☰</button>
        </div>
        <nav className="nav-menu">
          {renderMenu(visibleMenuItems)}
        </nav>
      </aside>

      <div className="main-content">
        {/* <header className="header">
          <button className="mobile-menu-btn" onClick={() => setDrawerOpen(true)}>☰</button>
          <h1 className="header-title">{systemName} Admin Panel</h1>
        </header> */}
    <header className="header">
  <div className="header-left">
    <button className="mobile-menu-btn" onClick={() => setDrawerOpen(true)}>☰</button>
    <h1 className="header-title">{tHeader("title", "{systemName} Admin Panel").replace("{systemName}", systemName)}</h1>
  </div>

  <div className="header-center hidden md:flex">
    <HeaderSearch items={searchableItems} />
  </div>

  <div className="header-right">
    <LanguagePicker />
    <NotificationBell />

    <ProfileMenu />
  </div>
</header>



        <main className="content">
          <div className="content-inner">
            <Outlet />
          </div>
        </main>
        <footer className="main-footer">
          <p>© {new Date().getFullYear()} {systemName} — {tFooter("rights_text", "All Rights Reserved")}</p>
        </footer>
      </div>
    </div>
  );
}
//الاصلي